import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TypeCache } from '../cache/type.cache';
import { AspectCache } from '../cache/aspect.cache';
import { PrototypeCache } from '../cache/prototype.cache';
import { FactionCache } from '../cache/faction.cache';
import { CacheAggregator } from '../cache/cache.aggregator';
import { InputCache } from '../cache/input.cache';
import { RoleCache } from '../cache/role.cache';
import { UnitCache } from '../cache/unit.cache';
import { ClientCache } from '../cache/client.cache';
import { ClubCache } from '../cache/club.cache';
import { EndpointCache } from '../cache/endpoint.cache';
import { CastCache } from '../cache/cast.cache';

@NgModule({ declarations: [], imports: [CommonModule], providers: [
        TypeCache,
        AspectCache,
        PrototypeCache,
        FactionCache,
        InputCache,
        RoleCache,
        UnitCache,
        ClientCache,
        ClubCache,
        EndpointCache,
        CastCache,
        CacheAggregator
    ] })
export class CacheModule { }
export * from '../cache/type.cache';
export * from '../cache/aspect.cache';
export * from '../cache/prototype.cache';
export * from '../cache/faction.cache';
export * from '../cache/input.cache';
export * from '../cache/role.cache';
export * from '../cache/unit.cache';
export * from '../cache/client.cache';
export * from '../cache/club.cache';
export * from '../cache/endpoint.cache';
export * from '../cache/cast.cache';
